import React from 'react'
import '../App.css'
import Bodyhomeadmincambios from './bodyhomeadmincambios'
export class Bodyapphomebodyadmincambios extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className='w-full'>
                <Bodyhomeadmincambios />
            </div>
        );
    }
}